<template>
  <div>
    <div class="page-toolbar">
      <div class="page-title">资质管理</div>
      <div class="toolbar-actions">
        <el-input
          v-model.trim="keyword"
          placeholder="按姓名/公司/手机过滤"
          clearable
          style="width: 280px;"
          @input="handleFilterChange"
        />
        <el-select v-model="statusFilter" clearable placeholder="全部状态" style="width: 140px;" @change="handleFilterChange">
          <el-option label="待审核" value="pending" />
          <el-option label="已通过" value="approved" />
          <el-option label="已驳回" value="rejected" />
        </el-select>
        <el-button icon="el-icon-refresh" @click="loadQualifications">刷新</el-button>
      </div>
    </div>

    <el-card class="page-card">
      <el-table :data="pagedRecords" v-loading="loading" stripe>
        <el-table-column type="index" :index="paginationIndex" width="56" label="#" />
        <el-table-column label="主体名称" min-width="170">
          <template slot-scope="{ row }">
            {{ row.companyName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="认证类型" width="100">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="applicantTypeTagType(row.applicantType)">
              {{ applicantTypeLabel(row.applicantType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" width="130" />
        <el-table-column prop="category" label="类目" width="120" />
        <el-table-column label="状态" width="110">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="statusType(row.status)">
              {{ statusLabel(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="保证金状态" width="120">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="paymentStatusType(row.paymentStatus)">
              {{ paymentStatusLabel(row.paymentStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="submitTime" label="提交时间" width="170" />
        <el-table-column prop="reviewComment" label="审核备注" min-width="180" />
        <el-table-column label="操作" width="250" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" @click="showDetail(row)">查看</el-button>
            <el-button
              size="mini"
              type="success"
              :disabled="row.status !== 'pending'"
              @click="handleReview(row, 'approved')"
            >
              通过
            </el-button>
            <el-button
              size="mini"
              type="danger"
              :disabled="row.status !== 'pending'"
              @click="handleReview(row, 'rejected')"
            >
              驳回
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="list-pagination">
        <el-pagination
          background
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="pageSizes"
          :total="filteredRecords.length"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
        />
      </div>
    </el-card>

    <el-drawer
      title="资质详情"
      :visible.sync="drawerVisible"
      size="720px"
      direction="rtl"
    >
      <div class="detail-wrap" v-loading="detailLoading">
        <template v-if="currentRecord">
          <div class="detail-actions">
            <el-button size="mini" type="primary" plain @click="editQualificationUser(currentRecord)">编辑资料</el-button>
          </div>
          <el-descriptions :column="1" border>
            <el-descriptions-item :label="identityNameLabel(currentRecord.applicantType)">
              {{ currentRecord.companyName || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="认证类型">
              {{ applicantTypeLabel(currentRecord.applicantType) }}
            </el-descriptions-item>
            <el-descriptions-item label="联系电话">{{ currentRecord.phone || '-' }}</el-descriptions-item>
            <el-descriptions-item :label="identityCodeLabel(currentRecord.applicantType)">
              {{ currentRecord.idNumber || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="经营类目">{{ currentRecord.category || '-' }}</el-descriptions-item>
            <el-descriptions-item label="经营地址">{{ currentRecord.address || '-' }}</el-descriptions-item>
            <el-descriptions-item label="提交时间">{{ currentRecord.submitTime || '-' }}</el-descriptions-item>
            <el-descriptions-item label="审核状态">
              <el-tag size="mini" :type="statusType(currentRecord.status)">
                {{ statusLabel(currentRecord.status) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="保证金状态">
              <el-tag size="mini" :type="paymentStatusType(currentRecord.paymentStatus)">
                {{ paymentStatusLabel(currentRecord.paymentStatus) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="支付方式">{{ paymentMethodLabel(currentRecord.paymentMethod) }}</el-descriptions-item>
            <el-descriptions-item label="支付金额">{{ paymentAmountText(currentRecord.paymentAmountFen) }}</el-descriptions-item>
            <el-descriptions-item label="商户单号">{{ currentRecord.paymentOrderNo || '-' }}</el-descriptions-item>
            <el-descriptions-item label="微信单号">{{ currentRecord.paymentTransactionId || '-' }}</el-descriptions-item>
            <el-descriptions-item label="支付时间">{{ currentRecord.paymentPaidAt || '-' }}</el-descriptions-item>
            <el-descriptions-item label="审核备注">{{ currentRecord.reviewComment || '-' }}</el-descriptions-item>
            <el-descriptions-item label="补充说明">{{ currentRecord.description || '-' }}</el-descriptions-item>
          </el-descriptions>

          <div class="detail-section" v-if="currentRecord.images && currentRecord.images.length">
            <div class="section-title">资质照片</div>
            <div class="image-list">
              <el-image
                v-for="(image, index) in currentRecord.images"
                :key="`${index}-${image}`"
                :src="image"
                fit="cover"
                :preview-src-list="currentRecord.images"
                class="image-item"
              />
            </div>
          </div>
          <UserProfileChangeLogList ref="qualificationChangeLogList" :openid="currentRecord.openid" />
        </template>

        <el-empty v-else description="暂无资质详情" />
      </div>
    </el-drawer>
    <UserProfileQualificationEditDialog
      :visible.sync="editDialogVisible"
      :openid="editingOpenid"
      @saved="handleProfileSaved"
    />
  </div>
</template>

<script>
import { fetchQualificationDetail, fetchQualifications, reviewQualification } from '../../api/admin'
import { isAuthRedirectError } from '../../utils/auth'
import UserProfileChangeLogList from '../../components/UserProfileChangeLogList.vue'
import UserProfileQualificationEditDialog from '../../components/UserProfileQualificationEditDialog.vue'

export default {
  name: 'QualificationListView',
  components: {
    UserProfileChangeLogList,
    UserProfileQualificationEditDialog
  },
  data() {
    return {
      loading: false,
      records: [],
      keyword: '',
      statusFilter: '',
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50, 100],
      drawerVisible: false,
      detailLoading: false,
      currentDetail: null,
      editDialogVisible: false,
      editingOpenid: ''
    }
  },
  computed: {
    filteredRecords() {
      const keyword = String(this.keyword || '').toLowerCase()
      const statusFilter = String(this.statusFilter || '')
      return this.records.filter((row) => {
        const matchKeyword = !keyword || [row.companyName, row.phone]
          .map(item => String(item || '').toLowerCase())
          .some(text => text.includes(keyword))
        const matchStatus = !statusFilter || row.status === statusFilter
        return matchKeyword && matchStatus
      })
    },
    pagedRecords() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.filteredRecords.slice(start, start + this.pageSize)
    },
    currentRecord() {
      return this.currentDetail && this.currentDetail.record ? this.currentDetail.record : null
    }
  },
  created() {
    this.loadQualifications()
  },
  methods: {
    applicantTypeLabel(applicantType) {
      if (applicantType === 'individual') return '个人'
      if (applicantType === 'company') return '企业'
      return '-'
    },
    applicantTypeTagType(applicantType) {
      return applicantType === 'individual' ? 'warning' : 'success'
    },
    identityNameLabel(applicantType) {
      return applicantType === 'individual' ? '个人姓名' : '公司名称'
    },
    identityCodeLabel(applicantType) {
      return applicantType === 'individual' ? '身份证号' : '统一社会信用代码'
    },
    statusType(status) {
      if (status === 'approved') return 'success'
      if (status === 'rejected') return 'danger'
      if (status === 'pending') return 'warning'
      return 'info'
    },
    statusLabel(status) {
      if (status === 'approved') return '\u5df2\u901a\u8fc7'
      if (status === 'rejected') return '\u5df2\u9a73\u56de'
      if (status === 'pending') return '\u5f85\u5ba1\u6838'
      return status || '\u672a\u77e5'
    },
    paymentStatusType(status) {
      if (status === 'disabled') return 'info'
      if (status === 'paid') return 'success'
      if (status === 'failed' || status === 'closed' || status === 'refunded') return 'danger'
      if (status === 'unpaid') return 'warning'
      return 'info'
    },
    paymentStatusLabel(status) {
      if (status === 'disabled') return '已关闭'
      if (status === 'paid') return '已支付'
      if (status === 'failed') return '支付失败'
      if (status === 'closed') return '已关闭'
      if (status === 'refunded') return '已退款'
      if (status === 'unpaid') return '待支付'
      return '-'
    },
    paymentMethodLabel(method) {
      if (method === 'WECHAT') return '微信支付'
      return method || '-'
    },
    paymentAmountText(amountFen) {
      const amount = Number(amountFen)
      if (!Number.isFinite(amount) || amount < 0) {
        return '-'
      }
      return `¥${(amount / 100).toFixed(2)}`
    },
    paginationIndex(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    handleFilterChange() {
      this.currentPage = 1
    },
    handlePageSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
    },
    handleCurrentPageChange(page) {
      this.currentPage = page
    },
    adjustCurrentPage() {
      const maxPage = Math.max(1, Math.ceil(this.filteredRecords.length / this.pageSize))
      this.currentPage = Math.min(this.currentPage, maxPage)
    },
    async loadQualifications() {
      this.loading = true
      try {
        this.records = await fetchQualifications()
        this.adjustCurrentPage()
      } catch (error) {
        if (isAuthRedirectError(error)) return
        this.$message.error(error.message || '\u8d44\u8d28\u5217\u8868\u83b7\u53d6\u5931\u8d25')
      } finally {
        this.loading = false
      }
    },
    async showDetail(row) {
      this.drawerVisible = true
      this.detailLoading = true
      try {
        this.currentDetail = await fetchQualificationDetail(row.openid)
      } catch (error) {
        this.currentDetail = null
        if (isAuthRedirectError(error)) return
        this.$message.error(error.message || '\u8d44\u8d28\u8be6\u60c5\u83b7\u53d6\u5931\u8d25')
      } finally {
        this.detailLoading = false
      }
    },
    editQualificationUser(row) {
      if (!row || !row.openid) return
      this.editingOpenid = row.openid
      this.editDialogVisible = true
    },
    async handleProfileSaved() {
      const openid = this.editingOpenid
      await this.loadQualifications()
      if (this.drawerVisible && this.currentRecord && this.currentRecord.openid === openid) {
        await this.showDetail({ openid })
        this.$nextTick(() => {
          if (this.$refs.qualificationChangeLogList) {
            this.$refs.qualificationChangeLogList.loadLogs()
          }
        })
      }
    },
    handleReview(row, status) {
      const title = status === 'approved' ? '\u901a\u8fc7\u5ba1\u6838' : '\u9a73\u56de\u5ba1\u6838'
      const placeholder = status === 'approved'
        ? '\u53ef\u586b\u5199\u5ba1\u6838\u5907\u6ce8\uff08\u9009\u586b\uff09'
        : '\u5efa\u8bae\u586b\u5199\u9a73\u56de\u539f\u56e0'
      this.$prompt(`\u8bf7\u8f93\u5165${title}\u5907\u6ce8`, title, {
        inputValue: '',
        inputPlaceholder: placeholder,
        confirmButtonText: '\u786e\u8ba4',
        cancelButtonText: '\u53d6\u6d88'
      })
        .then(async ({ value }) => {
          await reviewQualification({
            openid: row.openid,
            status,
            reviewComment: String(value || '').trim()
          })
          this.$message.success('\u5ba1\u6838\u64cd\u4f5c\u6210\u529f')
          await this.loadQualifications()
          if (this.drawerVisible && this.currentRecord && this.currentRecord.openid === row.openid) {
            await this.showDetail(row)
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.list-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

.detail-wrap {
  padding: 0 8px 20px;
}

.detail-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.detail-section {
  margin-top: 20px;
}

.section-title {
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
}

.image-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.image-item {
  width: 100%;
  height: 110px;
  border-radius: 10px;
  overflow: hidden;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
</style>
